import { useState } from "react";
import ProductTypeTable from "../../pages/productType/productTypeList";
import { StatusBar } from "../../components/common";
import PageBodyWrapper from "../../components/PageBodyWrapper";
import useApi from "../../api";
import ProductTypeModal from "./modal";
import { useDispatch } from "react-redux";
import { fetchProductTypes } from "../../redux/productTypesSlice";
import { handleRetriveError } from "../../utils";



function ProductTypesMain() {
    const dispatch = useDispatch();
    const api = useApi();
    const [edit, setEdit] = useState<any>(null);
    const [openModal, setOpenModal] = useState(false);

  const onModalOpen = (editId?: number) => {
    setEdit(editId || null);
    setOpenModal(true);
  };

  const onModalClose = () => {
    setOpenModal(false);
    setEdit(null);
  };

  const onModalSubmit = () => {
    getProductType();
    onModalClose();
  };

  const getProductType = () => {
    api.getProductType().then(
      () => {
        dispatch(fetchProductTypes() as any);
      }, handleRetriveError);
  };


  return (
    <PageBodyWrapper>
      <StatusBar
        buttonLabel="Add Product Type"
        onButtonClick={() => setOpenModal(!openModal)}
        statusList={[]}
        currentStatus={null}
        onChangeStatus={() => {}}
      />
      <div className="px-1">
        <ProductTypeTable onModalOpen={onModalOpen} getProductType={getProductType} />
      </div>

      {openModal && (
        <ProductTypeModal
          isOpen={openModal}
          edit={edit}
          onClose={onModalClose}
          onSubmit={onModalSubmit}
        />
      )}
    </PageBodyWrapper>
  );
}

export default ProductTypesMain;
